import { render, staticRenderFns } from "./card-attachment.vue?vue&type=template&id=fd47ad78&scoped=true"
import script from "./card-attachment.vue?vue&type=script&lang=js"
export * from "./card-attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd47ad78",
  null
  
)

export default component.exports